import axios, { AxiosInstance, CreateAxiosDefaults } from "axios"
import { AuthService } from "../auth/auth_service";
import { getTenantSelectedId } from "../../state/tenant_state";

let saved_client: AxiosInstance | null = null;

export function getClient(extraConfig: CreateAxiosDefaults<unknown> = {}): AxiosInstance {
  if (saved_client) {
    return saved_client;
  }

  const client = axios.create({
    baseURL: import.meta.env.VITE_PDF_API,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },

    ...extraConfig
  });

  client.interceptors.request.use(async (config) => {
    const token = await AuthService.getInstance().getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Add tenant ID header if available
    const tenantId = getTenantSelectedId();
    if (tenantId && !config.headers['x-tenant-id']) {
      config.headers['x-tenant-id'] = tenantId;
    }

    return config;
  });
  saved_client = client;
  return client;
}
